export default {
  "failed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["退出登录失败"])}
}